import { default as module } from './AbstractModule';

export default class extends module {
    constructor(m) {
        super(m);

        this.events = {
            mouseenter: 'launch'
        }

        this.$emojied = this.$('emojied')
    }

    launch() {
        let i = 0
        for(let el of Array.from(this.$emojied)) {
            setTimeout(() => {
                el.classList.add('is-active')
            }, i * 100)
            i++
        }
    }
}
